import { render, staticRenderFns } from "./CroppedLayoutSettings.vue?vue&type=template&id=15efc0f0&"
import script from "./CroppedLayoutSettings.vue?vue&type=script&lang=js&"
export * from "./CroppedLayoutSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports